import { Box, Skeleton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import { lightPalette } from '../mui/palettes';
interface IProps {
  columns: GridColDef[];
}
const CustomDataGridSkeleton = ({ columns }: IProps) => {
  return (
    <Box>
      {/* Mock header row */}
      <Box display="flex" p={1} bgcolor={lightPalette.background.paper}>
        {columns.map((col) => (
          <Skeleton
            key={col.field}
            variant="text"
            width={col.width ?? '100%'}
            height={24}
            sx={{ mr: 2 }}
          />
        ))}
      </Box>

      {/* Skeleton rows */}
      {Array.from({ length: 5 }).map((_, i) => (
        <Box key={i} display="flex" p={1}>
          {columns.map((col) => (
            <Skeleton
              key={col.field}
              variant="rectangular"
              width={col.width ?? '100%'}
              height={40}
              sx={{ mr: 2, borderRadius: 1 }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default CustomDataGridSkeleton;
